var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1914 0H3.80859C2.35469 0 1.17188 1.18281 1.17188 2.63672V20L7.94922 16.6113L14.7266 20V10.5859H18.8281V2.63672C18.8281 1.18281 17.6453 0 16.1914 0ZM13.5547 2.63672V18.1039L7.94922 15.3011L2.34375 18.1039V2.63672C2.34375 1.82898 3.00086 1.17188 3.80859 1.17188H14C13.7189 1.59109 13.5547 2.09516 13.5547 2.63672ZM17.6562 9.41406H14.7266V2.63672C14.7266 1.82898 15.3837 1.17188 16.1914 1.17188C16.9991 1.17188 17.6562 1.82898 17.6562 2.63672V9.41406Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarks);
export default __webpack_public_path__ + "static/media/bookmarks.d8fe6b8c18fcc4709453ee7308b5392d.svg";
export { ForwardRef as ReactComponent };